import { BaseIcon } from './base';
import type { IconSmallProps } from './base';

export function IconStartsWith(props: IconSmallProps) {
  return (
    <BaseIcon {...props}>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M8 19H5V5H8C8.28333 5 8.52083 4.90417 8.7125 4.7125C8.90417 4.52083 9 4.28333 9 4C9 3.71667 8.90417 3.47917 8.7125 3.2875C8.52083 3.09583 8.28333 3 8 3H5C4.45 3 3.97917 3.19583 3.5875 3.5875C3.19583 3.97917 3 4.45 3 5V19C3 19.55 3.19583 20.0208 3.5875 20.4125C3.97917 20.8042 4.45 21 5 21H8C8.28333 21 8.52083 20.9042 8.7125 20.7125C8.90417 20.5208 9 20.2833 9 20C9 19.7167 8.90417 19.4792 8.7125 19.2875C8.52083 19.0958 8.28333 19 8 19ZM20.7071 11.2929C21.0976 11.6834 21.0976 12.3166 20.7071 12.7071L17.7071 15.7071C17.3166 16.0976 16.6834 16.0976 16.2929 15.7071C15.9024 15.3166 15.9024 14.6834 16.2929 14.2929L17.5858 13H10C9.44772 13 9 12.5523 9 12C9 11.4477 9.44772 11 10 11H17.5858L16.2929 9.70711C15.9024 9.31658 15.9024 8.68342 16.2929 8.29289C16.6834 7.90237 17.3166 7.90237 17.7071 8.29289L20.7071 11.2929Z"
        fill="currentColor"
      />
    </BaseIcon>
  );
}
